<script>
import core from '@/core';

export default {
  name: 'UlDialog',
  props: {
    active: {
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '400px',
    },
  },
  data: () => ({
    scroll: new core.utils.scroll.Scroll(),
  }),
  computed: {},
  watch: {
    active() {
      this.setScrollBody();
    },
  },
  methods: {
    setScrollBody() {
      this.scroll.enable = !this.active;
    },
  },
  mounted() {
    this.setScrollBody();
  },
  destroyed() {
    this.scroll.destroy();
  },
};
</script>
<template>
  <div class="ul-dialog" v-if="active">
    <div class="ul-dialog__bg" @click="$emit('update:active', !active)"></div>
    <div class="ul-dialog__wrap">
      <UlCard :style="{width: width}">
        <UlCardTitle border>ds</UlCardTitle>
        <slot></slot>
        <UlCardFooter border>ds</UlCardFooter>
      </UlCard>
    </div>
  </div>
</template>
<style lang="scss">
  .ul-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 5000;

    &__bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .5);
    }

    &__wrap {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>
